import { _ as _sfc_main } from "./VaConfig.vue_vue_type_script_lang-13fd387b.mjs";
import { resolveComponent, openBlock, createBlock, normalizeProps, mergeProps, withCtx, renderSlot } from "vue";
import { _ as _export_sfc } from "../../../plugin-vue_export-helper-cc2b3d55.mjs";
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CssVarsRenderer = resolveComponent("CssVarsRenderer");
  return _ctx.doRenderCssVars ? (openBlock(), createBlock(_component_CssVarsRenderer, normalizeProps(mergeProps({ key: 0 }, _ctx.$attrs)), {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16)) : renderSlot(_ctx.$slots, "default", { key: 1 });
}
const VaConfig = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  VaConfig as V
};
//# sourceMappingURL=VaConfig-594daf87.mjs.map
